import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './style/general.css';
import { SadFace, Tick } from '../icons';

export default function StateWrapper({
  children,
  hasErrored,
  hasSucceeded,
  isStateful,
  size,
}) {
  const iconClasses = cx(styles.icon, styles.iconHidden, {
    [styles.iconShown]: hasSucceeded || hasErrored,
  });

  const contentClasses = cx(styles.circularTransition, {
    [styles.contentHidden]: hasSucceeded || hasErrored,
  });

  if (isStateful) {
    return (
      <div className={styles.container}>
        <div className={styles.iconWrap}>
          <div className={iconClasses}>
            {hasSucceeded && <Tick size={size} />}
            {hasErrored && <SadFace size={size} />}
          </div>
        </div>
        <div className={contentClasses}>{children}</div>
      </div>
    );
  }

  return <div>{children}</div>;
}

StateWrapper.propTypes = {
  children: PropTypes.node,
  hasErrored: PropTypes.bool,
  hasSucceeded: PropTypes.bool,
  isStateful: PropTypes.bool,
  size: PropTypes.string,
};

StateWrapper.defaultProps = {
  children: null,
  hasErrored: false,
  hasSucceeded: false,
  isStateful: false,
  size: 'medium',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-button/StateWrapper/index.js